<template lang="pug">
header
    button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
        span.hamburger-box
            span.hamburger-inner
    .container.is-hidden-touch
        .columns
            .logo-wrapper
                img#logo.is-pulled-left(v-if="logo && logo.id" v-lazy="image" title="logo" rel="noopener")
                img#logo.is-pulled-left(v-else src="@/assets/kfd-logo.svg")
                //span.name(v-html="name")
            .main-menu-wrapper.column
                nav#main-menu.is-pulled-right
                    tree-menu(:items="items" :max-depth="3" :delay="400")
                //- a.search.icon.is-large(href="#" @click.prevent="openSearch")                            i.fas.fa-search
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";

import NestedSet from "@/nested-set-lib";

export default {
  name: "Header",
  computed: {
    items() {
      const menu = this.menus.find((menu) => menu.key === "main-menu");
      let items = _.get(menu, "menuItems") || [];
      items = _.cloneDeep(items);

      if (items.length) {
        return NestedSet.createTree(items);
      }

      return items;
    },
    image() {
      const storageRoute = _.trim(
        `${process.env.VUE_APP_API_ENDPOINT}${
          process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE
        }`,
        "/"
      );

      const fit = "fit=fill&w=350&h=150";

      let width = this.logo.width;
      let height = this.logo.height;

      return {
        src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
        error: `${storageRoute}/images/${this.logo.id}/${
          this.logo.name
        }?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${this.logo.id}/${
          this.logo.name
        }?${fit}&preview=blur`,
        width,
        height,
      };
    },
    name() {
      let name = "";
      // disable name for netzwek ost domains
      switch (this.baseURL) {
        case "kfd-netzwerk-ost.de":
        case "kfd-berlin.de":
        case "kfd-goerlitz.de":
        case "kfd-erfurt.de":
        case "kfd-magdeburg.de":
        case "kfd-dresden-meissen.de":
        case "kfd-muenchen.de":
        case "www.kfd-netzwerk-ost.de":
        case "www.kfd-berlin.de":
        case "www.kfd-goerlitz.de":
        case "www.kfd-erfurt.de":
        case "www.kfd-magdeburg.de":
        case "www.kfd-dresden-meissen.de":
        case "www.kfd-muenchen.de":
          return name;
      }
      if (this.CMS.name) {
        if (this.CMS.name.toLowerCase().startsWith("kfd")) {
          let replaced = this.CMS.name;
          replaced = replaced.replace("KFD", "");
          replaced = replaced.replace("kfd", "");
          replaced = replaced.replace("Kfd", "");
          name = replaced;
        } else name = this.CMS.name;
      }
      return name;
    },
    baseURL() {
      return window.location.host;
    },
    ...mapGetters({
      logo: "logo",
      menus: "menus",
      sidebar: "sidebar",
      CMS: "CMS",
    }),
  },
  methods: {
    openSearch() {
      // TODO
      // console.log('open search bar');
    },
    toggleSidebar() {
      this.updateSidebarVisibility(!this.sidebar);
    },
    ...mapMutations({
      updateSidebarVisibility: "updateSidebarVisibility",
    }),
  },
};
</script>

<style lang="sass" scoped>

@import "~bulma/sass/utilities/mixins"
@import '~@/assets/sass/variables'


header
    // padding-top: 50px
    // padding-bottom: 50px
    background: url('../assets/kreiskreuz-header.png') no-repeat right top
    border-bottom: 1px solid var(--color-border-menu)
    .name
        padding-top: 15px
        margin-bottom: 50px
    #logo
        height: 155px
        padding-top: 25px
    .hamburger
        height: 55px
        outline: none
        +desktop
            display: none

    .container
        margin-top: 0.75rem
        height: 253px
        .columns
            height: 100%
            .logo-wrapper
                display: flex
                justify-content: center
                flex-direction: column
                position: absolute
                height: 80%
                left: 0
                top: 0
            .main-menu-wrapper.column
                display: flex
                justify-content: flex-end
                a.search
                    height: 54px
                    width: 54px
                    &:hover
                        background-color: var(--color-primary)
                        color: var(--color-primary-invert)

    .main-menu-wrapper
        margin-top: auto
        padding-bottom: 0
        .navbar-item
            // color: #222222 !important

        #main-menu
            // z-index: 10
            & ::v-deep
                ul
                    &.tree-menu
                        & > li
                            transition: background-color .3s ease
                            &:not(.full-width)
                                position: relative
                            & > .tree-item a
                                text-decoration: none
                                font-weight: 800
                                text-transform: uppercase
                                color: var(--color-main-menu)
                                padding: 15px
                                display: inline-block
                                transition: color .3s ease
                            &.hover
                                background-color: var(--color-primary)
                                & > .tree-item a
                                    color: var(--color-primary-invert)
                            li
                                // padding: 0 9px
                                width: 100%
                                background-color: var(--color-primary)
                                display: inline-flex
                                
                                &.has-children
                                    & > .tree-item a
                                        &:after
                                            display: none
                                            font-family: 'Font Awesome 5 Solid'
                                            content: "\f078"
                                        svg:last-of-type
                                            color: inherit
                                            margin-left: 10px

                                & > .tree-item
                                    width: 100%
                                    a
                                        font-weight: normal
                                        color: var(--color-primary-invert)
                                        display: block
                                        //max-width: 300px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        width: 100%
                                        &:before
                                            display: none
                                            font-family: 'Font Awesome 5 Solid'
                                            content: "\f054"
                                        svg
                                            color: inherit
                                            margin-right: 6px
                                            // transition: color .3s ease
                                &.hover
                                    background-color: var(--color-primary-invert)
                                    & > .tree-item a
                                        color: var(--color-main-menu)
                                        &:before
                                            color: var(--color-main-menu)

                & > ul
                    &.tree-menu
                        & > li
                            // padding: 0 9px 33px 9px
                            display: inline-block
                            & > .tree-item a
                                padding: 15px 24px 28px 24px
                                border-bottom: 5px solid transparent
                                &.router-link-exact-active
                                    color: var(--color-primary)
                                    border-bottom: 5px solid var(--color-primary)
                            &.hover > .tree-item a.router-link-exact-active
                                color: var(--color-primary-invert)
                            & > ul
                                &.tree-menu
                                    position: absolute
                                    left: 0
                                    top: 100%
                                    display: flex
                                    flex-direction: column
                                    min-width: 100%
                                    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                    
                                    &.full-width
                                        background: var(--color-primary)
                                        width: 100%
                                        columns: 3
                                        column-gap: 0
                                        display: block
                                        +widescreen
                                            columns: 4
                                        li > .tree-item
                                            width: 100%
                                            a
                                                max-width: initial
                                    
                        ul ul
                            min-width: 200px
                            margin-bottom: 9px
                            position: absolute
                            right: 100%
                            top: 0
                            z-index: 100
                            // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                            li > .tree-item a
                                // padding: 10px 15px
                                // font-size: .8rem
                                // &:before
                                //     font-size: 0.5rem
                                //     position: relative
                                //     top: -1px

                .show-enter-active, .show-leave-active
                    transition: opacity 0.3s ease, transform 0.3s ease
                    transform-origin: left center
                .show-enter, .show-leave-to
                    opacity: 0
                    transform: translateY(6px)
</style>
